<div class="logo">
  <img src="assets/general/logo.png" />
  <p>بنتو</p>
</div>
<div class="title">جنسیت خود را مشخص کنید</div>

<div class="gender-box">
  <div
    class="gender-item"
    (click)="genderSelect(1)"
    [ngClass]="{ active: gender == 1 }"
  >
    <img src="assets/authentication/woman.svg" class="woman" alt="" />
    زن
  </div>
  <div
    class="gender-item"
    (click)="genderSelect(0)"
    [ngClass]="{ active: gender == 0 }"
  >
    <img src="assets/authentication/man.svg" class="man" alt="" />

    مرد
  </div>
</div>

<!-- <div class="gender-holder">
  <div class="container">
    <div class="img-holder" (click)="genderSelect(1)">
      <img src="assets/general/female.png" />
    </div>
    <button
      class="submit-active"
      (click)="genderSelect(1)"
      *ngIf="gender === 1"
    >
      <div class="title-active">خانم</div>
    </button>
    <div
      class="submit-disable"
      (click)="genderSelect(1)"
      *ngIf="gender === undefined || gender === 0"
    >
      <div class="title-disable">خانم</div>
    </div>
  </div>
  <div class="container">
    <div class="img-holder" (click)="genderSelect(0)">
      <img src="assets/general/male.png" />
    </div>
    <button
      class="submit-active"
      (click)="genderSelect(0)"
      *ngIf="gender === 0"
    >
      <div class="title-active">آقا</div>
    </button>
    <div
      class="submit-disable"
      (click)="genderSelect(0)"
      *ngIf="gender === undefined || gender === 1"
    >
      <div class="title-disable">آقا</div>
    </div>
  </div>
</div> -->
